export const szzRegionFrag = `
    id
    code
    name
`;
